/* eslint-disable react/jsx-no-useless-fragment */
import { CSSProperties } from "react"

import {
  Link,
  LinkTag,
  WidgetTag,
  connect,
  isInPlaceEditingActive,
  provideComponent
} from "scrivito"
import { alignmentClassName } from "scrivito/Widgets/utils/alignmentClassName"
import { alternativeTextForObj } from "scrivito/Widgets/utils/alternativeTextForObj"
import { ScrivitoImage } from "scrivito/scrivito-image/ScrivitoImage"

import { ImageWidget } from "./ImageWidgetClass"
import "./styles/_image-widget.scss"

provideComponent(ImageWidget, ({ widget }) => {
  const classNames = ["image-widget"]
  const alignment = alignmentClassName(widget.get("alignment"))
  if (alignment) classNames.push(alignment)

  let style: CSSProperties | undefined
  const height = widget.get("height")
  if (height) style = { ...style, height }
  const width = widget.get("width")
  if (width) style = { ...style, width }
  const objectFit = widget.get("objectFit")
  if (height && objectFit === "cover") style = { ...style, objectFit }

  return (
    <WidgetTag className={classNames.join(" ")}>
      <LinkWrapper link={widget.get("link")}>
        <ScrivitoImage
          alt={
            widget.get("alternativeText") ||
            alternativeTextForObj(widget.get("image"))
          }
          className={widget.get("roundCorners") ? "rounded" : undefined}
          attribute="image"
          content={widget}
          style={style}
        />
      </LinkWrapper>
    </WidgetTag>
  )
})

const LinkWrapper = connect(
  ({ link, children }: { link: Link | null; children: React.ReactNode }) => {
    if (isInPlaceEditingActive()) return <>{children}</>
    if (!link) return <>{children}</>

    return <LinkTag to={link}>{children}</LinkTag>
  }
)
